export default __webpack_public_path__ + "static/media/appStatusLOProcessing.be571589.png";